import { emptyResults } from 'Common/utilities/apidata';
import { getStore } from 'stores/common/selectors';
import { APIData } from 'utils/apidata';
import { OauthRedirect } from './generators';

export function oauthRedirect(state: any): APIData<OauthRedirect> {
  const store = getStore(state);
  return store.oauth.handleOauthRedirect ?? emptyResults;
}

export const selectors = {
  oauthRedirect,
};
